import { Injectable } from '@angular/core'
import { BehaviorSubject, Observable } from 'rxjs'
import { ButtonConfiguration } from './button-configuration.interface'

@Injectable({
    providedIn: 'root',
})
export class BreadcrumbButtonBarService {
    private buttonsSubject = new BehaviorSubject<ButtonConfiguration[]>([])
    buttons$ = this.buttonsSubject.asObservable()

    addButton(buttonConfig: ButtonConfiguration) {
        const currentButtons = this.buttonsSubject.getValue()
        currentButtons.push(buttonConfig)
        this.buttonsSubject.next(currentButtons)
    }

    removeButton(index: number) {
        const currentButtons = this.buttonsSubject.getValue()
        currentButtons.splice(index, 1)
        this.buttonsSubject.next(currentButtons)
    }
    removeAllButtons() {
        this.buttonsSubject.next([])
    }

    getButtons(): Observable<ButtonConfiguration[]> {
        return this.buttons$
    }
}
